import { RootState } from '../types';

export const coOccuringConditionsSelector = (state: RootState) => state.upset.cooccuringconditions;
